<template>
	<LayoutWithContainer>
		<template slot="header">
            <ContentHeader title="Reports" :bordered="false">
                <template slot="actions">
                    <button @click.prevent.stop="$modal.show('new-report')" class="btn">Create Report</button>
                </template>
            </ContentHeader>
		</template>
		<vue-tabs ref="tabs" @tab-change="onTabChange">
			<v-tab id="opportunities" title="Opportunities">
				<ReportTabOpportunities ref="opportunities" />
			</v-tab>
			<v-tab id="madds" title="MADDs">
				<ReportTabMADDs ref="madds" />
			</v-tab>
		</vue-tabs>
        <modal name="new-report" :adaptive="true" height="auto" :maxHeight="900">
            <form @submit.prevent.stop="handleSubmit" class="form" ref="form">
                <h2>Create Report</h2>
                <FormControlReportType
                    name="type"
                    v-model="formData.type"
                    :resource="currentTab"
                />
                <FormControlSector
                    name="sectors"
                    v-model="formData.sectors"
                    :multiple="true"
                    :include-ancestors="false"
                    v-if="showSectors"
                />
                <FormControlDatepicker
                    name="fromDate"
                    v-model="formData.fromDate"
                    label="From date"
                />
                <FormControlDatepicker
                    name="toDate"
                    v-model="formData.toDate"
                    label="To date"
                />
                <button
                    type="submit"
                    :class="{'btn': true, 'btn--action': true, 'active': $wait.is('creating_report') }"
                >
                    <Spinner :height="13" :width="13" color="#ffffff" v-if="$wait.is('creating_report')" />
                    <span v-else>Submit</span>
                </button>
            </form>
        </modal>
	</LayoutWithContainer>
</template>

<script>
    import API from '@api';
    import SearchModalForm from '@components/SearchModal/Form';
    import FormControlDatepicker from '@components/Form/Control/FormControlDatepicker';
    import FormControlSector from '@components/Form/Control/FormControlSector';
    import FormControlReportType from '@components/Form/Control/FormControlReportType';
    import ReportTabOpportunities from './Tab/ReportTabOpportunities';
    import ReportTabMADDs from './Tab/ReportTabMADDs';
    import ReportTabIntelligence from './Tab/ReportTabIntelligence';
    import ReportTabInsights from './Tab/ReportTabInsights';
	import TabbedPage from '../TabbedPage';
	import LayoutList from '../Layout/LayoutList';
    import Spinner from '@components/Spinner.vue';
    import LayoutWithContainer from '@layouts/LayoutWithContainer.vue';
    import ContentHeader from '@components/Header/ContentHeader.vue';

	export default {
		name: 'ReportList',
		mixins: [TabbedPage],
		components: {
            ContentHeader,
            LayoutWithContainer,
            Spinner,
            FormControlReportType,
            FormControlSector,
            FormControlDatepicker,
            SearchModalForm,
			ReportTabInsights,
			ReportTabIntelligence,
			ReportTabMADDs,
			ReportTabOpportunities,
			LayoutList,
		},
		data() {
			return {
				defaultTab: 'opportunities',
				tabRoute: 'reports',
                formData: {
                    type: '',
                    sectors: '',
                    fromDate: '',
                    toDate: '',
                }
			}
		},
        computed: {
            showSectors: function() {
                return this.currentTab === 'opportunities' || this.currentTab === 'madds';
            }
        },
        methods : {
            handleSubmit: function() {
                this.$wait.start('creating_report');

                API.createReport({
                    resource: this.currentTab,
                    ...this.formData,
                })
                    .then(() => {
                        if(this.$refs[this.currentTab]){
                            this.$refs[this.currentTab].load();
                        }
                        this.$refs.form.reset();
                        this.formData = {
                            type: '',
                            sectors: '',
                            fromDate: '',
                            toDate: '',
                        };
                        this.$modal.hide('new-report');
                    })
                    .finally(() => {
                        this.$wait.end('creating_report');
                    });
            }
        }
	}
</script>

<style lang="scss" scoped>
</style>
